// @ts-nocheck

import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Target } from '../client';
import { selectUserConnected } from '../selectors/user/userPrimary.selector';
import { showWebsiteLoginForm } from '../utils';
import RoutesRedirectionFactory from '../utils/routes/RoutesRedirectionFactory';

import useRouter from './useRouter';

const useShowLogin = () => {
  const { history } = useRouter();
  const isUserConnected = useSelector(selectUserConnected);

  useEffect(() => {
    if (!isUserConnected) {
      if (!Target.__MOBILE__) {
        showWebsiteLoginForm();
      } else if (history?.push) {
        history.push(RoutesRedirectionFactory.getLoginRouteConfig());
      }
    }
  }, [history, isUserConnected]);
};

export default useShowLogin;
